import './buckhotel/style';
import FormStructure from './buckhotel/form_structure';

export default FormStructure;